import { render, staticRenderFns } from "./HotWordAnalysis.vue?vue&type=template&id=0fc2f69a&scoped=true"
import script from "./HotWordAnalysis.vue?vue&type=script&lang=js"
export * from "./HotWordAnalysis.vue?vue&type=script&lang=js"
import style0 from "./HotWordAnalysis.vue?vue&type=style&index=0&id=0fc2f69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc2f69a",
  null
  
)

export default component.exports